import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const warrantySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Registration", {
          context: "merchant settings label for warranty registration",
        });
      },
      permission: SettingsPermissions.SET_WARRANTY_SETTINGS,
    },
    path: "registrations",
    lazy: async () => {
      const { WarrantyRegistrationSettings } =
        await import("../../../../setting/registration-settings");
      return { element: <WarrantyRegistrationSettings /> };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Registration rewards", {
          context: "merchant settings label for warranty registration rewards",
        });
      },
      permission: SettingsPermissions.SET_WARRANTY_SETTINGS,
    },
    path: "registration-rewards",
    lazy: async () => {
      const { RegistrationRewards } =
        await import("../../../../setting/registration-rewards");
      return { element: <RegistrationRewards /> };
    },
  },
];
